module.exports = __webpack_public_path__ + "src/assets/img/base-musicbox.891103a6.png";